import React, {useState} from 'react'
import {CardBox, CardButtonBox, CardText} from '../BaseCard/styles'
import {Button} from '../../../../components/button'
import {Challenge} from '../../../../redux/challenges'

import Challenge30Logo from '../../../../images/study-challenge-logo.svg'
import Challenge30DaysDialog from '../../../../components/Challenge30DaysDialog'
import {useQuery} from '../../../../hooks/useQuery'

type Props = {
  challenge: Challenge
  showCard?: boolean
  courseId?: string
}

const View = ({challenge, showCard, courseId}: Props) => {
  const query = useQuery()

  const [isChallengeDialogOpen, setIsChallengeDialogOpen] = useState(
    query.get('showChallengeDialog') === 'true' && !challenge.hasEntry,
  )

  return (
    <>
      {showCard && (
        <CardBox>
          <CardText>
            <img src={Challenge30Logo} />
          </CardText>
          <CardText style={{marginTop: '16px'}}>
            Structured 30-day plan & community support to help you pass your
            next ARE exam.
          </CardText>
          <CardButtonBox>
            <Button
              color="secondary"
              children={'Participate Now'}
              onClick={() => setIsChallengeDialogOpen(true)}
            />
          </CardButtonBox>
        </CardBox>
      )}
      <Challenge30DaysDialog
        open={isChallengeDialogOpen}
        setOpen={(value: boolean) => setIsChallengeDialogOpen(value)}
        challenge={challenge}
        courseId={courseId}
      />
    </>
  )
}

export default View
